// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3Noc-","label":"Category_label__2Oj95","content":"Category_content__1qcBE","header":"Category_header__1cQm-","location":"Category_location__2E9nF"};